import { setObjectValue, Dep } from "../../../framework/Processes";
import { External } from "../../../framework/comp/Lambda/Constructors";
import { FunctionType } from "../../../framework/comp/Types";

export default {
	name: 'task_0_2',
	description: 'Заставка',
	title: 'Выбор сложности',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите сложность вопросов",
			options: [
                'Базовая: я ещё мало знаю по этой теме',
                'Продвинутая: я чувствую уверенность в своих знаниях',
			],
			correct: [0]
        };
	},
	postprocess: Dep(External(function(state) {
		const { history } = state.objects;
		const playerChoice = history[history.length - 1].playerAns;
		return setObjectValue("difficulty", playerChoice);
	}, "Function", FunctionType("Object", "Process"))),
	isCompleted: () => true,
};